import { URLS } from "@/constants/api-endpoints";
import axios from "axios";
import { deleteAccessToken } from "@/store/user";
import { clearUserDetails } from "@/store/user-details";

const getStore = () => require("@/store/store").store;

const authenticatedUserService = axios.create({
  baseURL: URLS.base_url,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
  },
});

authenticatedUserService.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      const token = getStore().getState().user?.accessToken;
      const securityGroup = getStore().getState().user?.selectedSecurityGroup;
      const isSuperUser = getStore().getState().user?.loginData?.superUser;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["is-Super-Admin"] = String(isSuperUser ?? false);
      }
      if (securityGroup) {
        config.headers["X-Security-Group-Id"] = securityGroup.securityGroup;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

authenticatedUserService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthenticated! Redirecting to login...");
      const isSuperUser = getStore().getState().user?.loginData?.superUser;
      getStore().dispatch(deleteAccessToken());
      getStore().dispatch(clearUserDetails());
      const redirectTo = isSuperUser ? "/de/s-admin/login" : "/de/login";
      window.location.href = redirectTo;
    }
    return Promise.reject(error);
  },
);

export default authenticatedUserService;
